export default __webpack_public_path__ + "static/5- maps-experience-e7eb7ecd93eb3b8735cdd3f255097a16.gif";